import styles from './index.module.scss'
import { Image, message } from 'antd'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { LoadingOutlined, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons'
import useComposeLongImage from '../useComposeLongImage'
import useDownloadSelectedImagesZip from '../useDownloadSelectedImagesZip'
import useDownloadLongDetailImage from '../useDownloadLongDetailImage'

const PreviewBottomActions = forwardRef(({ imageUrls = [], selectedTaskIds = [], selectedDownloadItems = [], isGenerating = false }, ref) => {
    const { compose, clear, loading, longImageUrl } = useComposeLongImage()
    const { downloadSelected, loading: downloadLoading } = useDownloadSelectedImagesZip()
    const { downloadLongImage, loading: longDownloadLoading } = useDownloadLongDetailImage()
    const [previewVisible, setPreviewVisible] = useState(false)

    useEffect(() => {
        if (!previewVisible) {
            clear()
        }
    }, [imageUrls, previewVisible, clear])

    const handlePreviewLongImage = async () => {
        const resultUrl = await compose(imageUrls)
        if (!resultUrl) {
            message.warning('暂无可预览图片')
            return
        }
        setPreviewVisible(true)
    }

    useImperativeHandle(ref, () => ({
        previewLongImage: handlePreviewLongImage,
    }), [handlePreviewLongImage])

    const handleDownloadSelected = async () => {
        if (isGenerating) {
            message.warning('生成中，请等待完成后再下载')
            return
        }
        const downloadItems = selectedDownloadItems?.length ? selectedDownloadItems : selectedTaskIds
        const { successCount, failCount } = await downloadSelected(downloadItems, `已选图_${Date.now()}.zip`)
        if (successCount > 0 && failCount > 0) {
            message.warning(`下载完成，${failCount} 张下载失败`)
            return
        }
        if (successCount > 0) {
            message.success('下载成功')
            return
        }
        message.error('下载失败')
    }

    const handleDownloadLongDetail = async () => {
        if (isGenerating) {
            message.warning('生成中，请等待完成后再下载')
            return
        }
        const downloadItems = selectedDownloadItems?.length ? selectedDownloadItems : selectedTaskIds
        const success = await downloadLongImage(downloadItems, {
            fileName: `详情页长图_${Date.now()}.png`,
        })
        if (success) {
            message.success('下载成功')
            return
        }
        message.error('下载失败')
    }

    return (
        <div className={styles.PreviewBottomActions}>
            <div className={styles.Actions}>
                <button
                    type="button"
                    className={styles.GhostBtn}
                    onClick={handlePreviewLongImage}
                    disabled={loading}
                >
                    {loading && <LoadingOutlined className={styles.LoadingIcon} spin />}
                    预览长图
                </button>
                <button
                    type="button"
                    className={styles.PrimaryBtn}
                    onClick={handleDownloadLongDetail}
                    disabled={longDownloadLoading}
                >
                    {longDownloadLoading && <LoadingOutlined className={styles.LoadingIcon} spin />}
                    下载详情页长图
                </button>
                <button
                    type="button"
                    className={styles.PrimaryBtn}
                    onClick={handleDownloadSelected}
                    disabled={downloadLoading}
                >
                    {downloadLoading && <LoadingOutlined className={styles.LoadingIcon} spin />}
                    下载已选图
                </button>
            </div>
            {!!longImageUrl && (
                <Image
                    style={{ display: 'none' }}
                    src={longImageUrl}
                    preview={{
                        visible: previewVisible,
                        onVisibleChange: (visible) => setPreviewVisible(visible),
                        toolbarRender: (_, { actions }) => (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                <ZoomOutOutlined
                                    style={{ fontSize: 20, color: '#fff', cursor: 'pointer' }}
                                    onClick={actions?.onZoomOut}
                                />
                                <ZoomInOutlined
                                    style={{ fontSize: 20, color: '#fff', cursor: 'pointer' }}
                                    onClick={actions?.onZoomIn}
                                />
                            </div>
                        ),
                    }}
                />
            )}
        </div>
    )
})

export default PreviewBottomActions
